import { clsx, type ClassValue } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

/**
 * `cn` — clsx for conditionals, tailwind-merge for conflicts.
 *
 * WHY THIS IS NOT THE TWO-LINE VERSION. tailwind-merge resolves conflicts by
 * bucketing every class into a group and keeping the last one in each group.
 * It infers the group from the class NAME, so a custom utility that merely
 * looks like a core one is silently filed under it.
 *
 * That bit hard. The design system's `bg-brand`
 * set `background-image`, but tailwind-merge read the `bg-` prefix and filed
 * them as background-COLOUR — so `cn("bg-primary", "bg-brand")` returned just
 * `bg-brand`, and every surface that took the brand fill lost its background
 * colour. The primary button rendered as an invisible white rectangle. tsc,
 * the test suite, the drift gate and `next build` were all green; only a
 * screenshot caught it.
 *
 * So the three are declared in the group they actually belong to. Any future
 * utility whose name collides with a core Tailwind namespace has to be
 * declared here too — that is the cost of an idiomatic name, and it is worth
 * paying once rather than renaming the utilities to something unidiomatic.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      // These paint `background-image`, and must not evict `bg-<colour>`.
      "bg-image": ["bg-brand"],
      // These are `transition-property` shorthands, in the same group as
      // Tailwind's own `transition-*` so the last one still wins.
      transition: ["transition-control", "transition-tint"],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
